import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { memo } from "react";
import { FinancialDocumentListItem } from "@common/types/financialDocument";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { Button } from "@design-system/Button/Button";
import { ZoomInIcon } from "@icons";
import { HStack } from "@design-system/HStack/HStack";
import { DocumentSelectTableMeta } from "./financialDocumentSelectViewConfig";

export const SelectActionsCell = memo(
    ({
        row,
        table,
    }: CellContext<ViewTableFeatures, FinancialDocumentListItem, unknown>) => {
        const document = row.original;
        const meta = table.options.meta as DocumentSelectTableMeta | undefined;

        return (
            <ViewTableCell>
                <HStack as="span" justify="end" gap={12}>
                    <Button
                        variant="primary"
                        iconOnly
                        size="sm"
                        aria-label="Preview document"
                        onClick={() => meta?.callbacks?.onPreviewed?.(document)}
                    >
                        <ZoomInIcon />
                    </Button>

                    {meta?.callbacks?.cta?.(document)}
                </HStack>
            </ViewTableCell>
        );
    },
);
